import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';

import { common, toggle, components } from '@nt-workspace/common';
import coreModules from './modules/core-modules';

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();

console.log('Init core modules');
coreModules.init();

common.video.init();
common.lazyLoadMedia.init();

components.quickSearch.init();
components.siteSearch.init();

const toggles = document.querySelectorAll('.js-toggle');
if (toggles.length) {
  for (let toggleEl of toggles) {
    toggle.initToggle(toggleEl);
  }
}

const accordionTabs = document.querySelectorAll('.js-accordion-tabs');
if (accordionTabs.length) {
  accordionTabs.forEach((accordion) => {
    common.accordionTabs.init(accordion);
  });
}

const mediaCarousels = document.querySelectorAll('.js-media-carousel');
if (mediaCarousels.length) {
  mediaCarousels.forEach((gallery) => {
    components.mediaCarousel.initMediaCarousel(gallery);
  });
}

const tabs = document.querySelectorAll('.js-tabs');
if (tabs.length) {
  tabs.forEach((tab) => {
    common.tabs.init(tab);
  });
}

const timeToRead = document.querySelectorAll('.js-time-to-read');
if (timeToRead.length) {
  timeToRead.forEach((el) => {
    common.timeToRead.init(el);
  });
}

const listingFilters = document.getElementById('listing-filters');
if (listingFilters) {
  components.listingFilters.initListingFilters(listingFilters);
}

// Media gallery elements
const mediaGalleries = document.querySelectorAll('[data-media-gallery]');
if (mediaGalleries.length > 0) {
  for (let el of mediaGalleries) {
    common.initMediaGallery(el);
  }
}

// Virtual select
const selects = document.querySelectorAll('[data-virtual-select]');
if (selects.length > 0) {
  selects.forEach((select) => {
    common.select.init(select);
  });
}

// JS filter
const jsFilters = document.querySelectorAll('.js-filter');
if (jsFilters.length > 0) {
  jsFilters.forEach((select) => {
    common.jsFilter.init(select);
  });
}

// CSR charts
if (document.querySelectorAll('.highcharts-chart').length) {
  import(
    /* webpackChunkName: 'highcharts-chart', webpackMode: 'lazy' */ '../../../common/js/helpers/charts'
  ).then((m) => {
    // jshint ignore:line
    m.default.init();
  });
}

const heroAnimate = document.querySelectorAll('.js-hero-animate');
if (heroAnimate.length) {
  common.heroAnimate.init();
}

// Contact point/locations map
if (document.querySelectorAll('.map').length) {
  import(
    /* webpackChunkName: 'gmaps-map', webpackMode: 'lazy' */ '../../../nt-corporate/src/js/modules/maps'
  ).then((m) => {
    // jshint ignore:line
    m.default.init();
  });
}

// React & Share consent module
const rnsElements = document.querySelectorAll('[data-rns]');
if(rnsElements.length) {
  import(/* webpackChunkName: "rns", webpackMode: "lazy" */'./modules/react-and-share').then(m => {
    for (let element of rnsElements) {
      new m.default(element);
    }
  });
}
